import { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { DEFAULT_LANGUAGE, LANGUAGES } from '../i18n/language';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(
        localStorage.getItem('language') || DEFAULT_LANGUAGE
    );

    useEffect(() => {
        document.documentElement.lang = language;
        document.documentElement.dir = language === "fa" ? "rtl" : "ltr";
    }, [language]);

    const changeLanguage = (nextLanguage) => {
        if (!Object.values(LANGUAGES).includes(nextLanguage)) return;

        localStorage.setItem('language', nextLanguage);
        document.documentElement.lang = nextLanguage;
        // document.documentElement.dir = nextLanguage === 'fa' ? 'rtl' : 'ltr';

        setLanguage(nextLanguage);
    };

    const value = useMemo(() => ({
        language,
        changeLanguage,
        isFa: language === LANGUAGES.fa,
    }), [language]);

    return (
        <LanguageContext.Provider value={ value }>
            { children }
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);

    if (!context) {
        throw new Error('useLanguage باید داخل LanguageProvider استفاده شود');
    }

    return context;
};
